// react
import React, { useState, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// store
import { routes } from "../../store/routes";
import { resetPasswordService } from "../../store/services/ServiceResetPassword";
import { isEmpty, isEmailError } from "../../store/services/helpers/validation";
// components
import ButtonSubmit from "../../components/buttons/ButtonSubmit";
import ModalResponse from "../../components/modals/ModalResponse";
import { Form } from "semantic-ui-react";

// component
function ResetPasswordForm({ userEmail }) {
    // state
    const [email, setEmail] = useState(userEmail);
    const [isProcessing, setIsProcessing] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalIsError, setModalIsError] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    const openModal = (message, error) => {
        setModalMessage(message);
        setModalIsError(error);
        handleModalOpen();
    };

    const handleModalOpen = () => {
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsProcessing(true);

        // validate form fields
        let formError = false;
        if (isEmailError(email)) {
            formError = true;
        }

        if (!formError) {
            // send request for reset password
            if (await resetPasswordService.requestResetPassword(email)) {
                openModal(
                    "Žiadosť na obnovenie hesla bola odoslaná na Váš email",
                    false
                );
            } else {
                openModal(
                    "Žiadosť na obnovenie hesla sa nepodarilo odoslať!",
                    true
                );
            }
        }

        setIsProcessing(false);
    };

    // template
    return (
        <Fragment>
            <style>{`
                .reset-password-form-card {
                    padding: 2rem 1.5rem;
                    max-width: 450px;
                    width: 100%;
                    margin: 0 auto;
                    box-sizing: border-box;
                }
                @media (min-width: 768px) {
                    .reset-password-form-card {
                        padding: 3rem 2.5rem;
                    }
                }
            `}</style>
            <div className="reset-password-form-card" style={{
                background: 'var(--white)',
                borderRadius: '20px',
                border: '1px solid #e0e0e0',
                boxShadow: '0 5px 20px rgba(214, 12, 140, 0.10)',
                position: 'relative',
                width: '100%',
                maxWidth: '450px',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    textAlign: 'center',
                    marginBottom: '2rem'
                }}>
                    <Link to={routes.HOME} style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
                        <img
                            src="/images/logos/logo_dark_version.png"
                            width="180"
                            style={{
                                display: "block",
                                margin: "0 auto",
                                maxWidth: '100%',
                                height: 'auto'
                            }}
                            alt="Activity Point logo"
                        />
                    </Link>
                </div>
                <Form onSubmit={handleSubmit}>
                    <Form.Field width={16}>
                        <Form.Input
                            size="large"
                            required
                            autoFocus
                            fluid
                            label="Email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={
                                !isEmpty(email)
                                    ? isEmailError(email)
                                    : false
                            }
                            style={{
                                marginBottom: '1.25rem'
                            }}
                        />
                    </Form.Field>

                    <ButtonSubmit
                        fluid={true}
                        loading={isProcessing}
                        disabled={isProcessing || isEmpty(email)}
                        text="Odoslať žiadosť na obnovenie hesla"
                    />
                </Form>
            </div>

            <ModalResponse
                open={modalOpen}
                onClose={handleModalClose}
                icon={modalIsError ? "warning circle" : "checkmark"}
                header={
                    !modalIsError ? "Požiadavka odoslaná" : "Chyba pri odoslaní"
                }
                message={modalMessage}
                onClick={handleModalClose}
            />
        </Fragment>
    );
}

export default connect()(ResetPasswordForm);
